import type { TranslationTree } from '../../types';

export const profile: TranslationTree = {
  profile: {
    hero: {
      badge: 'Persönlicher Bereich',
      title: 'Willkommen, {{name}}',
      subtitle: 'Passen Sie Ihre ToolLife-Erfahrung an und schützen Sie Ihre Zugänge.',
      emailLabel: 'E-Mail-Adresse',
      anonymous: 'Benutzer',
    },
    overview: {
      title: 'Profil & Zugänge',
      description: 'Kontoinformationen und aktivierte Module.',
      emailLabel: 'Anmelde-E-Mail',
      emailFallback: 'Nicht angegeben',
      modulesTitle: 'Aktive Module',
      modulesHelper: 'Diese Zugänge bestimmen, welche Funktionen verfügbar sind.',
      modulesCount: '{{count}} Modul(e)',
      modulesEmpty: 'Für Ihr Konto ist derzeit kein Modul aktiviert.',
    },
    modules: {
      chip: {
        traceability: 'Rückverfolgbarkeit',
        analytics: 'Analysen',
        machineLearning: 'Prädiktive Wartung',
      },
    },
    preferences: {
      title: 'Interface-Einstellungen',
      description: 'Passen Sie Darstellung und Sprache der Anwendung an.',
      themeLabel: 'Thema',
      languageLabel: 'Sprache',
    },
    security: {
      title: 'Kontosicherheit',
      description: 'Aktualisieren Sie Ihr Passwort und schützen Sie Ihre Zugangsdaten.',
    },
    password: {
      title: 'Passwort ändern',
      fields: {
        current: {
          label: 'Aktuelles Passwort',
          placeholder: 'Aktuelles Passwort eingeben',
        },
        new: {
          label: 'Neues Passwort',
          placeholder: 'Neues Passwort festlegen',
        },
        confirm: {
          label: 'Passwort bestätigen',
          placeholder: 'Neues Passwort bestätigen',
        },
      },
      actions: {
        submit: 'Neues Passwort speichern',
        submitting: 'Speichern…',
      },
      status: {
        success: 'Ihr Passwort wurde aktualisiert.',
      },
      errors: {
        mismatch: 'Das neue Passwort und die Bestätigung stimmen nicht überein.',
        default: 'Passwort konnte nicht aktualisiert werden.',
        client: 'Benutzersitzung nicht gefunden. Bitte melden Sie sich erneut an.',
      },
    },
  },
};
